import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback, initAuth } from "../lib/auth";

export function AuthCallbackPage(): JSX.Element {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        await initAuth();
        await handleCallback();
        navigate("/", { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
      }
    })();
  }, [navigate]);

  return (
    <div className="h-full flex items-center justify-center bg-ink-900 text-white">
      {error ? (
        <div className="bg-red-900/60 border border-red-700 rounded-xl px-4 py-3 max-w-md">
          Logowanie nie powiodło się: {error}
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 border-2 border-ink-600 border-t-lime-400 rounded-full animate-spin" />
          <span>Finalizuję logowanie…</span>
        </div>
      )}
    </div>
  );
}
